<template>
  <div>
    <v-alert
      app
      v-if="one_user && is_new_user"
      type="info"
      dense
      icon="mdi-account-star"
    >
      <v-row class="px-1" align='center' justify='space-between'>

        <span>
          <strong>Bem vindo</strong> 
          Para acessar todas as funcionalidades, solicite a um Administrador da empresa que adicione você a um departamento.
        </span>
        <!-- <v-btn small color="white" class="black--text" @click="goToPlansPage">Planos</v-btn> -->

      </v-row>
    </v-alert>
    <!-- <v-dialog
      v-if="one_user && is_new_user"
      v-model="dialog"
      scrollable 
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-center">
          <span class="headline">Bem-vindo, {{ one_user.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <span class="d-flex justify-center body-1">
                  <p>Seja bem-vindo ao Checkbits.</p> 
                </span>
                <span class="body-2">
                  <p>Para acessar todas as funcionalidades contate um Administrador da empresa.</p>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'WelcomeNewUser',
    data() {
      return {
        dialog: true
      }
    },
    methods: {
      showDialog() {
        if (this.one_user && this.is_new_user) {
          this.$swal({
            title: `Bem-vindo, ${this.one_user.name}`,
            text: 'Para acessar todas as funcionalidades contate um Administrador da empresa.',
            icon: 'info',
            confirmButtonText: 'Fechar',
            confirmButtonColor: this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].secondary,
            width: 800
          });
        }
      },
    },
    computed: {
      is_new_user() {
        if (this.one_user) {
          const user_departments_ids = this.one_user.department_ids;
          const company_new_user_department_id = this.one_user.company.data.attributes.new_users_department_id;
  
          if (user_departments_ids.includes(company_new_user_department_id)) {
            return true;
          } else {
            return false;
          }
        }

        return false;
      },
      ...mapState({
        one_user: state => state.User.oneUser
      })
    },
    watch: {
      one_user(newValue, oldValue) {
        if (newValue) {
          this.showDialog();
          this.dialog = true;
        } else if (newValue == false) {
          this.dialog = false
        }
      }
      // is_new_user(newValue, oldValue) {
      //   console.log('is_new_user', newValue, oldValue);
      //   if (newValue && newValue == true && this.one_user) {
      //     this.showDialog();
      //     this.dialog = true;
      //   } else if (newValue == false) {
      //     this.dialog = false
      //   }
      // }
    },
  }
</script>

<style lang="scss" scoped>

</style>